import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  signal,
  ViewChild,
  AfterViewInit
} from '@angular/core';
import * as feather from 'feather-icons';
import { RouterOutlet } from '@angular/router';
import { NavService } from 'src/app/shared/services/nav.service';
import { LayoutService } from 'src/app/shared/services/layout/layout.service';
import { slider } from '../../../data/animation/route-animations';
import { TiktokTokenCheckerService } from '../../../../core/tiktok-token-checker/tiktok-token-checker.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { BannerComponent } from '../../banner/banner.component';
import { SharedModule } from '../../../shared.module';
import { NgClass, NgStyle } from '@angular/common';
import { ModalConnectTiktokComponent } from '../../../../features/auth/modal-connect-tiktok/modal-connect-tiktok.component';
import { ImportProgressService } from '../../../../services/import-progress.service';
import { AgencyStateService } from '../../../../core/services/agency-state.service';

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss'],
  imports: [BannerComponent, SharedModule, NgStyle, NgClass, ModalConnectTiktokComponent],
  animations: [slider]
})
export class ContentComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('banner') bannerComponent: BannerComponent;
  // V5 fix (bd-r3mv): the previous ProRenameNoticeComponent ViewChild and
  // its banner-offset accounting were removed together with the standalone
  // Pro-rename banner. The Pro rename announcement is now a standard entry
  // in the Notification Center (bell-icon dropdown) and does not occupy the
  // page-header strip, so banner offset state is once again driven solely
  // by BannerComponent.

  footerDark: boolean;
  footerLight: boolean;
  footerFix: boolean;
  Scorlled: boolean;
  tiktokAuthorized = signal<boolean>(true);
  public show: boolean = true;
  public width = window.innerWidth;
  public screenwidth: any = window.innerWidth;
  private unsubscribe$: Subject<void> = new Subject<void>();
  public showBanner: boolean = false;
  public isDemoMode: boolean = false;
  public multipleBanners: boolean = false;

  constructor(
    public navServices: NavService,
    public layout: LayoutService,
    private _tiktokTokenCheckerService: TiktokTokenCheckerService,
    private importProgressService: ImportProgressService,
    public agencyState: AgencyStateService
  ) {
    // Initialize WebSocket connection when the app loads
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.screenwidth = event.target.innerWidth;

    if (this.screenwidth < 991) {
      return (this.layout.config.settings.sidebar = 'compact-wrapper');
    } else {
      return (this.layout.config.settings.sidebar =
        this.layout.config.settings.sidebar || 'horizontal-wrapper');
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      feather.replace();
      const applyOffsetState = () => {
        // BannerComponent is the sole contributor to the page-body offset
        // state since the Pro-rename top banner was removed (bd-r3mv).
        const bannerCount = this.bannerComponent?.getVisibleBannersCount() ?? 0;
        const bannerVisible = this.bannerComponent?.isAnyBannerVisible() ?? false;
        const demoMode = this.bannerComponent?.isDemoMode ?? false;
        if (this.showBanner !== bannerVisible) {
          this.showBanner = bannerVisible;
        }
        if (this.isDemoMode !== demoMode) {
          this.isDemoMode = demoMode;
        }
        const multiple = bannerCount > 1;
        if (this.multipleBanners !== multiple) {
          this.multipleBanners = multiple;
        }
      };
      applyOffsetState();
      const checkBannerInterval = setInterval(applyOffsetState, 200);
      this.unsubscribe$.subscribe(() => {
        clearInterval(checkBannerInterval);
      });
    });

    // Log WebSocket connection status
    setTimeout(() => {
      this.importProgressService
        .getConnectionStatus()
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((connected: boolean) => {});
    }, 1000);
  }

  public getRouterOutletState(outlet: any) {
    return outlet.isActivated ? outlet.activatedRoute : '';
  }

  ngOnInit(): void {
    // Ensure ImportProgressService is initialized and connected
    const connectionStatus = this.importProgressService.isConnected();

    // Add diagnostic information
    setTimeout(() => {
      const diagnostics = this.importProgressService.getDiagnostics();
    }, 2000);

    setTimeout(() => {
      const diagnostics = this.importProgressService.getDiagnostics();
    }, 5000);

    this._tiktokTokenCheckerService.tikTokTokenState$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data: boolean) => {
        this.tiktokAuthorized.set(data);
      });
  }

  ngDoCheck() {
    if (window.location.pathname == '/page-layout/footer-dark') {
      this.footerDark = true;
      this.footerLight = false;
      this.footerFix = false;
      this.Scorlled = false;
    } else if (window.location.pathname == '/page-layout/footer-light') {
      this.footerLight = true;
      this.footerDark = false;
      this.footerFix = false;
      this.Scorlled = false;
    } else if (window.location.pathname == '/page-layout/footer-fixed') {
      this.footerFix = true;
      this.footerLight = false;
      this.footerDark = false;
      this.Scorlled = false;
    } else if (window.location.pathname == '/page-layout/hide-nav-scroll') {
      this.Scorlled = true;
      this.footerFix = false;
      this.footerLight = false;
      this.footerDark = false;
    }
  }

  @HostListener('window:scroll', [])
  scrollHandler() {
    let number =
      window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (window.location.pathname == '/page-layout/hide-nav-scroll') {
      if (number > 600) {
        this.show = true;
      } else this.show = number === 0;
    }
  }

  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
